/*
 * @Author: your name
 * @Date: 2021-11-11 13:10:32
 * @LastEditTime: 2022-04-23 16:48:45
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\components\tabbar\index.js
 */

export default{
    data() {
        return {
            
        }
    },
    props:{
        value: Boolean,
        showConfirmButton: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            default: '75%'
        },
        height: {
            type: String,
            default: '268px'
        },
        confirmButtonStyle: {
            type: String,
            default: ''
        },
        confirmButtonText: {
            type: String,
            default: '我知道了'
        },
        showCancelButton: {
            type: Boolean,
            default: false
        },
        cancelButtonText: {
            type: String,
            default: '取消'
        },
        hideCloseBtn :{
            type: Boolean,
            default: false
        },
    },
    methods: {
        confirm() {
            this.$emit("confirm")
        },
        close() {
            this.$emit('close')
        },
    },
    created() {
    },
    computed: {
    }
}